var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm-row1"},[_vm._t("default",null,{"gutter":_vm.gutter})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }